// Fake device consumption per room (last 7 days, kWh/day) for Apartment Administration view.
// Realistic weekly totals: Living ~25, Kitchen ~32, Bedroom ~18, Bathroom ~38 → sum ~113; scaled to match apartment total with ~6% Other.
export const ROOM_DEVICES = {
    livingRoom: {
        id: 'livingRoom',
        nameKey: 'livingRoom',
        icon: 'ac_unit',
        devices: [
            { id: 'ac-living', name: 'AC', labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'], consumption: [3.2, 3.5, 3.0, 3.8, 3.4, 4.2, 3.6].map(String) },
        ],
    },
    kitchen: {
        id: 'kitchen',
        nameKey: 'kitchen',
        icon: 'kitchen',
        devices: [
            { id: 'fridge', name: 'Fridge', labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'], consumption: [2.2, 2.3, 2.1, 2.2, 2.4, 2.5, 2.2].map(String) },
            { id: 'oven', name: 'Oven', labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'], consumption: [0.8, 1.8, 1.2, 1.4, 1.2, 2.0, 1.0].map(String) },
        ],
    },
    bedroom: {
        id: 'bedroom',
        nameKey: 'bedroom',
        icon: 'bed',
        devices: [
            { id: 'ac-bedroom', name: 'AC', labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'], consumption: [2.2, 2.4, 2.0, 2.6, 2.2, 2.8, 2.4].map(String) },
        ],
    },
    bathroom: {
        id: 'bathroom',
        nameKey: 'bathroom',
        icon: 'bathtub',
        devices: [
            { id: 'washing', name: 'Washing Machine', labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'], consumption: [0.4, 1.2, 0.2, 0.8, 1.4, 1.8, 0.5].map(String) },
            { id: 'boiler', name: 'Boiler', labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'], consumption: [4.2, 4.5, 4.0, 4.8, 4.4, 5.2, 4.6].map(String) },
        ],
    },
};

export const getRoomsOrder = () => ['livingRoom', 'kitchen', 'bedroom', 'bathroom'];

// Seeded hash for deterministic per-apartment variation (0..1).
const seeded = (str) => {
    let h = 0;
    for (let i = 0; i < str.length; i++) h = Math.imul(31, h) + str.charCodeAt(i) | 0;
    return (Math.abs(h) % 1000) / 1000;
};

// Returns device data with consumption varied per apartment so charts differ.
export const getRoomDevicesForApartment = (apartmentId) => {
    if (!apartmentId) return ROOM_DEVICES;
    const out = {};
    getRoomsOrder().forEach((roomKey) => {
        const room = ROOM_DEVICES[roomKey];
        if (!room?.devices) return;
        out[roomKey] = {
            ...room,
            devices: room.devices.map((device) => {
                const base = (device.consumption || []).map(Number);
                const varied = base.map((v, i) => {
                    const r = seeded(`${apartmentId}-${device.id}-${i}`);
                    const factor = 0.65 + 0.7 * r;
                    return String(Math.round(v * factor * 100) / 100);
                });
                return { ...device, consumption: varied };
            }),
        };
    });
    return out;
};
